import { Box, Stack, Tooltip } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { Control, FieldValues, Path, UseFormWatch } from 'react-hook-form'
import FormField from '../../../../../components/Form/FormField'
import FormAutocomplete from '../../../../SingleRequestPage/components/SingleRequestDrawer/elements/FormAutocomplete'
import TypedAccordion from '../../../../SingleRequestPage/components/SingleRequestDrawer/elements/TypedAccordion'

interface EquipmentFormValues {
  serialNumber: string
  serviceCenterMalfunctionId?: string
  receiverModelName?: string
  serviceCenterComment?: string
  [key: string]: any // Для других возможных полей формы
}
type EquipmentDataAccordionProps<T extends FieldValues> = {
  control: Control<T>
  watch: UseFormWatch<T>
}

const EquipmentDataAccordion = <T extends EquipmentFormValues>(
  props: EquipmentDataAccordionProps<T>,
) => {
  const { control, watch } = props

  return (
    <TypedAccordion summary={'Данные оборудования'} customOpen>
      <Stack spacing={'14px'} marginTop={'16px!important'}>
        <FormField
          control={control}
          name={'serialNumber' as Path<T>}
          fullWidth
          label='S/N оборудования'
          onlyNumbers
          error={watch('serialNumber' as Path<T>)?.length !== 23}
          inputProps={{
            maxLength: 23,
          }}
          disabled
        />
        {watch('serviceCenterMalfunctionId' as Path<T>) && (
          <>
            <FormAutocomplete
              control={control}
              name={'receiverModelName' as Path<T>}
              fullWidth
              label='Модель оборудования'
              withoutTyping
              options={[]}
              disabled
            />

            <Tooltip
              placement='top'
              title={watch('serviceCenterMalfunctionId' as Path<T>)}
              disableHoverListener={
                !watch('serviceCenterMalfunctionId' as Path<T>)
              }
            >
              <Box position={'relative'}>
                <FormAutocomplete
                  control={control}
                  name={'serviceCenterMalfunctionId' as Path<T>}
                  fullWidth
                  label='Тип неисправности от Сервис-центра'
                  withoutTyping
                  options={[]}
                  error={!watch('serviceCenterMalfunctionId' as Path<T>)}
                  fullHeight
                  disabled
                />
              </Box>
            </Tooltip>
            <FormField
              control={control}
              name={'serviceCenterComment' as Path<T>}
              fullWidth
              placeholder=''
              label='Комментарий для СЦ'
              multiline
              rows={2}
            />
          </>
        )}
      </Stack>
    </TypedAccordion>
  )
}

export default observer(EquipmentDataAccordion)
